import { Stack } from 'expo-router';

export default function PublicTenantLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
